/**
 * Business scope types for local/regional brand identification
 * Used to tailor search query generation and analysis
 */

export type BusinessScope =
  | 'LOCAL'           // Single city or county level
  | 'REGIONAL'        // Multiple states (e.g., Southeastern US)
  | 'NATIONAL'        // Entire country (US or Canada)

export interface BrandLocationData {
  businessScope: BusinessScope
  serviceAreas: string[]       // ["San Diego, CA", "Los Angeles, CA"]
  primaryLocation?: string     // "San Diego, CA"
}

/**
 * Business scope labels for UI display
 */
export const BUSINESS_SCOPE_LABELS: Record<BusinessScope, string> = {
  LOCAL: 'Local',
  REGIONAL: 'Regional',
  NATIONAL: 'National'
}

/**
 * Business scope descriptions for onboarding
 */
export const BUSINESS_SCOPE_DESCRIPTIONS: Record<BusinessScope, string> = {
  LOCAL: 'City or county level service area',
  REGIONAL: 'Multiple states (e.g., Southeastern US)',
  NATIONAL: 'Nationwide (US or Canada)'
}

/**
 * Validate location format (City, State or City, Country)
 */
export function isValidLocationFormat(location: string): boolean {
  // Match "City, ST" or "City, Country" format
  const pattern = /^[A-Za-z\s]+,\s*[A-Za-z\s]+$/
  return pattern.test(location.trim())
}

/**
 * Format location string to standard format
 */
export function formatLocation(location: string): string {
  return location
    .split(',')
    .map(part => part.trim())
    .join(', ')
}
